import { createApp } from 'vue';
import DocxToMdConverter from '@/Components/DocxToMdConverter.vue';
import '@styles/app.css';

createApp(DocxToMdConverter).mount('#docx-to-md-converter');
